<template>
  <form class="custom-text-model-editor__form" novalidate @submit.prevent>
    <div style="padding: 1.5rem">
      <label class="form-label" for="theme-name">
        <VisibleText>Theme Name </VisibleText>
      </label>
      <input type="text" id="theme-name" v-model="newModel.name" />

      <Tagging class="tagging--gray" @add="addKeyword">
        <VisibleText>Keywords</VisibleText>
      </Tagging>
      <TaggingList :tags="newModel.keywords" @remove="removeKeyword" />
    </div>
    <div class="custom-text-model-editor__btns">
      <button
        class="btn-default"
        style="min-height: unset"
        type="submit"
        @click="onClickCreateTheme"
      >
        <VisibleText>Create theme</VisibleText>
      </button>
      <button class="btn-cancel" type="button" @click="$emit('close')">
        <VisibleText>cancel</VisibleText>
      </button>
    </div>
  </form>
</template>

<script>
// Components
import Tagging from '@/components/UI/Tagging/Tagging.vue';
import TaggingList from '@/components/UI/Tagging/TaggingList.vue';

// Models
import CustomTopicModel from '../Models/CustomTopicModel.js';
import CustomTopicModelGroup from '../Models/CustomTopicModelGroup.js';

// Services
import customTopicModelService from '@/services/customTopicModelService.js';

const INHERIT = ['lang', 'source', 'tags'];

export default {
  name: 'CustomTopicModelEditorNewTheme',
  components: {
    Tagging,
    TaggingList,
  },
  props: {
    topicModelGroup: {
      type: CustomTopicModelGroup,
      default: () => {},
    },
  },
  data() {
    return {
      CUSTOM_TOPIC_MODEL_SERVICE: new customTopicModelService(this.$pigeonline),
      newModel: new CustomTopicModel(),
      these_keywords: [],
    };
  },
  methods: {
    async onClickCreateTheme() {
      // populate inherited fields
      Object.assign(
        this.newModel,
        { group_id: this.topicModelGroup.id },
        ...INHERIT.map((k) => ({ [k]: this.topicModelGroup[k] })),
      );
      this.newModel['keywords'] = this.these_keywords; // Used as a temporary field for uploading
      try {
        const newTheme = await this.CUSTOM_TOPIC_MODEL_SERVICE.create(this.newModel);
        this.$emit('new-theme-created', newTheme);
        this.$emit('close');
      } catch (e) {
        throw new Error('onClickCreateTheme: ' + e.message);
      }
    },
    addKeyword(keyword) {
      this.these_keywords.push(keyword);
      this.newModel['keywords'] = this.these_keywords;
    },
    removeKeyword(keyword) {
      const indx = this.these_keywords.indexOf(keyword);
      if (indx === -1) return;
      this.these_keywords.splice(indx, 1);
      this.newModel['keywords'] = this.these_keywords;
    },
  },
};
</script>
